import Contributions_Controls = require("VSS/Contributions/Controls");

// Helper method to be used from the new webplatform (temporarily) to create contributed controls. 
// This method should be removed eventually.
export function createContributedControl(element: Element, contribution: Contribution) {
    return Contributions_Controls.createContributedControl($(element), contribution);
} 